import React from 'react';

const AddSkills = () => {
    // codelink demolink details id image title tools
    // const [livePhoto, setLivePhoto] = useState(null);

    return (
        <div className='px-5 flex justify-center mt-20'>
            <h2 className="text-2xl text-white">Comming soon</h2>
        </div>
    );
};

export default AddSkills;